export enum EProfileTabs {
  PersonalInfo = 0,
  IdentityDocuments = 1,
  KYC = 2,
  AdditionalDocuments = 3
}
